import React from 'react';
import PropTypes from 'prop-types';
import {
  arrayOf,
  customType,
  fragment,
  params,
  shape,
  string,
  useDataModel
} from '@thd-nucleus/data-sources';
import { CardCarouselRenderer } from './CardCarouselRenderer';

const CardCarousel = ({ entryId }) => {
  const { data, loading, error } = useDataModel('container', {
    variables: {
      context: {
        id: entryId
      }
    },
    skip: !entryId
  });

  if (!data || loading || error || !data.container || !data.container.recommendationsPodItems) {
    return null;
  }
  return (
    <CardCarouselRenderer
      data={data?.container}
      entryId={entryId}
      recPodList={data?.container?.recommendationsPodItems}
    />
  );
};

CardCarousel.propTypes = {
  entryId: PropTypes.string.isRequired
};

CardCarousel.displayName = 'CardCarousel';

CardCarousel.dataModel = {
  container: params({
    context: customType('QueryContext').shape({
      id: string().isRequired()
    })
  }).shape({
    RecommendationsPod: fragment().shape({
      id: string(),
      podTitle: string(),
      recommendationsPodItems: arrayOf(shape({
        id: string(),
        url: string(),
        anchorText: string(),
        image: shape({
          damContentSelector: shape({
            assetData: arrayOf(shape({
              selectedImageUrl: string()
            }))
          }),
          damDownloadedContent: shape({
            url: string()
          })
        }),
      }))
    }),
  }),
};

export { CardCarousel };
